import { useScriptTag } from '#imports'

import { noop } from '@backmarket/utils/function/noop'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import { useTrustmark } from '../useTrustmark'

export function useTrustedShopsLibrary() {
  const { withTrustedShops, trustmarkConfig } = useTrustmark()

  if (
    !withTrustedShops.value ||
    isEmpty(trustmarkConfig) ||
    !('id' in trustmarkConfig)
  ) {
    throw new Error('[TrustedShops] Missing id in trustmarkConfig')
  }

  const url = `//widgets.trustedshops.com/js/${trustmarkConfig.id}.js`

  return useScriptTag(url, noop)
}
